<template>
  <page>
    <template slot="content">
    <help-content :title="'WeBand3SCのリセット（接続QRコードの再表示）'">
      <template slot="content">
        <div class="text">
          WeBand3SCの動作や計測データがおかしいと感じた時に、以下の手順で本体をリセットすれば多くの場合は問題が解決できます。<br>
          ※リセットによって<b>WeBandに保存されているすべてのデータが消去される</b>ため、未同期の歩数データがあれば復元できません。ご留意ください。<br><br>
          ・WeBand3SC本体ボタン（下部の凹み部分）を数回タップし、Settings画面（歯車のアイコン）に切替えたら、本体ボタンを長押しして次の画面へ。<br><br>
          ・本体ボタンをタップしRecover画面に切替えたら、本体ボタンを長押しして次の画面へ。<br><br>
          ・Confirm?が表示されたら、本体ボタンを長押ししてプログレスバーが100％になれば再起動します。<br><br>
          ・本体の再起動が完了すれば、ペアリング用QRコードが表示されます。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H31.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help31.vue